import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import AlertContext from '../../../../../product/context/alert/alertContext'
import CustomTable from '../../../../../product/components/molecules/CustomTable'
import CommunicationContext from '../../../../../product/context/communication/communicationContext'
import { useTranslation } from 'react-i18next'

const UserEmailLogs = (props) => {
    const alertContext = useContext(AlertContext)
    const communicationContext = useContext(CommunicationContext)
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const { setAlert } = alertContext
    const {
        all_templates,
        getAllSearchTemplates,
        responseStatus: responseStatusCommuncation,
        clearResponse: clearResponseCommuncation,
    } = communicationContext
    const { t } = useTranslation()

    let action = 'emailLogs'

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                user_id: {
                    value: props.userId,
                    type: 'in',
                    field: 'lg.user_id',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllSearchTemplates(values)
        },
    })

    useEffect(() => {
        if (all_templates) {
            setTableBody(
                all_templates.records.length ? all_templates.records : []
            )
        }
        setIsLoading(false)
    }, [all_templates])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllSearchTemplates(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from === 'Communicationtemplates' &&
                responseStatusCommuncation.status === 'success'
            ) {
                setTableBody([])
                formik.values.action = action
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllSearchTemplates(formik.values)
            }
        }
    }, [responseStatusCommuncation])

    const tableValues = [
        {
            field: 'subject',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: t('Subject'),
        },
    ]

    if (action === 'emailLogs') {
        tableValues.push({
            field: 'email',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: t('Email'),
        })
    } else {
        tableValues.push({
            field: 'phone',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: t('Phone number'),
        })
    }
    tableValues.push({
        field: 'date_sent',
        type: 'datetime',
        firstChild: true,
        sort: true,
        disablePadding: false,
        label: t('Date sent'),
    })

    const searchInfo = [
        {
            label: t('Subject'),
            placeholder: 'Enter Subject',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
    ]

    if (action === 'emailLogs') {
        searchInfo.push({
            label: t('Email'),
            placeholder: 'Enter Email',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'emailsearch',
            formik: formik,
        })
    } else {
        searchInfo.push({
            label: t('Phone'),
            placeholder: 'Enter Subject',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'phonesearch',
            formik: formik,
        })
    }

    return (
        <>
            <CustomTable
                formik={formik.values}
                tableBody={tableBody}
                tableValues={tableValues}
                tableActions={[]}
                allData={all_templates}
                isLoading={isLoading}
                loadingTemplate={'table'}
                changeTableFunction={getAllSearchTemplates}
            />
        </>
    )
}
export default UserEmailLogs
